'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Tabs.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Tab component.
 */
var Tab = function Tab(_ref) {
  var label = _ref.label,
    selected = _ref.selected,
    href = _ref.href,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ['label', 'selected', 'href', 'onClick']);
  var active = (0, _classnames2.default)('c-tabs__item', {
    'c-tabs__item--active': selected
  });
  return _react2.default.createElement('a', _extends({
    className: active,
    href: href,
    onClick: onClick
  }, props), label);
};
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The text to display on the tab */
  label: _propTypes2.default.string.isRequired,
  /** Indicates if the tab is selected */
  selected: _propTypes2.default.bool,
  /** Specifies the URL of the link */
  href: _propTypes2.default.string,
  /** Function fired on click.*/
  onClick: _propTypes2.default.func
} : {};
Tab.defaultProps = {
  selected: false
};
exports.default = Tab;